module.exports = __webpack_public_path__ + "static/media/savemoney.fe6fb734.svg";